import { BlockchainService, StorageService } from '../services';
import { walletConnection } from './type';

export const connect = (formData) => (dispatch) => {
  try {
    let _walletDetails = {
      walletAddress: formData.walletAddress,
    };
    StorageService.setObject('wallet', _walletDetails);

    dispatch({
      type: walletConnection.SUCCESS,
      payload: _walletDetails,
    });
  } catch {
    dispatch({
      type: walletConnection.FAILURE,
    });
  }
};

export const disconnect = () => (dispatch) => {
  try {
    // StorageService.setObject("wallet", _walletDetails);
    StorageService.purgeData('wallet');
    let _metamaskResp = BlockchainService.isMetaMaskInstalled();
    //StorageService.clear();
    if (_metamaskResp.status === 'success') {
      window.ethereum.removeAllListeners();
    }

    dispatch({
      type: walletConnection.DISCONNECT,
      payload: null,
    });
  } catch {
    dispatch({
      type: walletConnection.FAILURE,
    });
  }
};
